import React from 'react';
import { useCursorStore } from '../../store/cursorStore';

const CursorLayer: React.FC = () => {
  const cursors = useCursorStore(s => s.cursors);
  return (
    <g id="layer-cursors" pointerEvents="none">
      {Object.entries(cursors).map(([id, c]) => (
        <g key={c.cursorId ?? id} transform={`translate(${c.x},${c.y})`}>
          <circle r={5} fill={c.color} opacity={0.8} />
          <text x={8} y={-6} fontFamily="'DM Mono',monospace" fontSize={9} fill={c.color}
            style={{ userSelect: 'none' }}>
            {c.displayName}
          </text>
        </g>
      ))}
    </g>
  );
};

export default CursorLayer;
